import React from 'react';
import {CollapsibleComponent, CollapsibleHead, CollapsibleContent} from 'react-collapsible-component';


class UINotes extends React.Component {

  static getPoolNote() {
    return (<div align="left">
      <hr/>
      <CollapsibleComponent name="note">
        <CollapsibleHead isExpanded={false}><font color="black"><b>Screen Guide</b> - click here for details</font>
        </CollapsibleHead>
        <CollapsibleContent isExpanded={false}>
          <ul>
            <li>A pool's performance and the rewards you earn by delegating your aion to a particular pool depends on many different factors. Please do your own research using Smart Stake tools before investing.</li>
            <li>Stake Weight is a percentage of the total AION staked on the network that are staked with this pool. Formula - Stake weight = (Number of Aion staked with the pool * 100) / Total number of Aion staked. Calculations use same measurement window (e.g. 1 hour, 24 hours) for all inputs to arrive at block weight for the measurement window.</li>
            <li>Block Weight is a percentage of the total AION validated on the network in a given day that are validated by this pool. Formula - Block weight = (Number of blocks validated * 100) / Total number of POS blocks validated.</li>
            <li>Block Index is a ratio of Block Weight and Stake Weight. Formula - Block index = (Block Weight * 100) / Stake Weight.</li>
            <li><font color="red">Average Block Index is an average of block index for a pool for last 21 completed days. The index can be really high (150+) or really low (0) for pools that have less than 2% stake. Do not use this metric in isolation for performance assessment of a pool.</font></li>
            <li><font color="red">Average Block Weight is an average of block weight for a pool for last 21 completed days. The weight can be really high (in proportion to Stake Weight) or really low for pools that have less than 2% of total stake.</font></li>
            <li><font color="red">Average Stake Weight is an average of stake weight for a pool for last 21 completed days.</font></li>
            <li><font color="red">Average Net Annual Rate of Return (ARR) is ARR calculated by factoring in the Fee charged by the pool and the pool's performance over last 21 days. It also includes actual number of POS blocks vs expected POS blocks at network level. Net ARR can be really high or really low for small pools. Net ARR is a historical metric. It is not a guarantee of future ARR. Do not use this metric in isolation for performance assessment of a pool.</font></li>
            <li><font color="red">Today's Stats - represent today's performance of a pool (GMT time). They are not meant to influence your decision to stake with a pool. They just represent current health/luck of a pool.</font></li>
            <li><font color="red">OAN Rating/Performance - The performance rating given to a pool by OAN's Staking Interface.</font></li>
            <li>Pools with smaller stake weight (e.g. less than 2% stake weight) will have bigger spikes (higher peaks/lower lows).</li>
            <li>The data captured is rounded at a per day level and as a result the variation in block/stake weight may have more spikes.</li>
            <ul>
              <li>A given pool losing significant delegates (in %).</li>
              <li>A given pool gaining significant delegates (in %).</li>
              <li>A given pool remaining stagnant while other pools gain/lose delegates.</li>
              <li>Private pools receiving/losing delegates.</li>
            </ul>
            <li>The tools created here are experimental in nature and designed to help the community make informed decisions about staking. Please DYOR and don't rely on the information provided here blindly. If you come across any bugs in this website, please contact the pool operator using contact information given at the bottom of the page.</li>
          </ul>
        </CollapsibleContent>
      </CollapsibleComponent>
    </div>);
  }

  static getDelegateHelp() {
    return (<div>
      <hr/>
      <CollapsibleComponent name="help">
        <CollapsibleHead isExpanded={false}><font color="black"><b>Screen Guide</b> - click here for details</font>
        </CollapsibleHead>
        <CollapsibleContent isExpanded={false}>
            <ul>
              <li>Estimated Pending Rewards - Undistributed rewards for an address. Formula used: undistributed rewards for pool * $aion staked by the address with the pool / total $aion staked with the pool.</li>
              <li>Address Stake weight - $aion staked by an address in one pool / total $aion staked by an address across all pools.</li>
              <li>Reward Weight - $aion rewards received for an address in one pool / total $aion rewards received for an address across all pools.</li>
              <li>Reward Index - Reward Weight for an address in one pool / Address Stake Weight for an address across all pools.</li>
            </ul>
        </CollapsibleContent>
      </CollapsibleComponent>
    </div>);
  }



}
// static getPoolNote() {
//   return (<div align="left">
//     <hr/>
//     <CollapsibleComponent name="note">
//       <CollapsibleHead isExpanded={false}>
//         <h4><font color="black">Screen Guide</font></h4>
//       </CollapsibleHead>
//       <CollapsibleContent isExpanded={false}>
//         <ul>
//           <li>A pool's performance and the rewards you earn by delegating your aion to a particular pool depends on many different factors. Please do your own research using Smart Stake tools and other means before investing.</li>
//           <li>Block weight = (Number of blocks validated * 100) / Total number of POS blocks validated. Calculations use same measurement window (e.g. 1 hour, 24 hours) for all inputs to arrive at block weight for the measurement window.</li>
//           <li>The stake weight shown does not consider historical stake weight. It considers only the current total stake weight of the pool.</li>
//           <li>The following factors affect Stake/Block Weight in current calculations:</li>
//           <ul>
//             <li>A given pool losing significant delegates (in %).</li>
//             <li>A given pool gaining significant delegates (in %).</li>
//             <li>A given pool remaining stagnant while other pools gain/lose delegates.</li>
//             <li>Private pools receiving/losing delegates.</li>
//           </ul>
//         </ul>
//       </CollapsibleContent>
//     </CollapsibleComponent>
//   </div>);
// }

export default UINotes;



// WEBPACK FOOTER //
// ./src/util/UINotes.js